/**
 * Panel slider (sorgente modulare)
 * Questo file verrà importato da `js/script.js` e compilato in `js/script.min.js`.
 */

export function initPanelSlider() {
  let panelSlider = document.querySelector('.PanelSlider');
  let panelSliderButtons = document.querySelectorAll('.PanelSliderButtons');

  if (!panelSlider || !panelSliderButtons) return;
  //Select first panel and button

  //if window.innerWidth is less than 820px, add the class 'mobile' to the panelSlider activate all panels
  if (window.innerWidth <= 820) {
    panelSlider.classList.add('mobile');
    panelSlider.querySelectorAll('.wp-block-group').forEach(panel => {
      panel.classList.add('active');
    });
    return;
  } else {
    panelSlider.classList.remove('mobile');
    activateSinglePanel('01');
    activateButton('01');

    panelSliderButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        panelSlider.classList.add('js-enabled');
        e.preventDefault();
        e.stopPropagation();
        let btn = e.target;
        activatePanel(btn);
      });
    });
  }

  // Click sul panel: attiva il panel cliccato (ma lascia liberi i click su link/bottoni interni)
  panelSlider.addEventListener('click', (e) => {
    if (!e.target) return;

    // se clicco un elemento interattivo dentro al panel (es. CTA), non interferisco
    if (e.target.closest('a, button, input, textarea, select, label')) return;

    // risalgo al panel vero e proprio (id tipo: data-panel-1)
    let panel = e.target.closest('[id^="data-panel-"]');
    if (!panel) return;

    let index = panel.id.replace('data-panel-', '').trim();
    if (!index || !index.length) return;

    panelSlider.classList.add('js-enabled');
    activateSinglePanel(index);
    activateButton(index);
  });
}

export const activatePanel = (button) => {
  let index = retrieveButtonIndex(button);
  if(!index || !index.length) return;
  activateSinglePanel(index);
  activateButton(index);
}

export const retrieveButtonIndex = (button) => {
  //if is not anchor, look for the anchor parent
  if (!button.matches('a')) {
    button = button.parentElement;

    if (!button.matches('a')) {
      button = button.parentElement;
    }
  }

  if (!button || !button.matches('a')) return;
  

  button.classList.add('active');

  //deactivate all sibling buttons
  button.parentElement.querySelectorAll('.kb-button').forEach(btn => {
    if (btn !== button) {
      btn.classList.remove('active');
    }
  });

  let href = button.getAttribute('href');
  if (!href) return;
  
  return href.replace('#data-ps-', '').trim();
}

export const activateSinglePanel = (index) => {
  
  let selectedPanel = document.getElementById('data-panel-' + index);
  if (!selectedPanel) return;
  selectedPanel.classList.add('active');
  selectedPanel.parentElement.querySelectorAll('.wp-block-group').forEach(panel => {
    if (panel !== selectedPanel) {
      panel.classList.remove('active');
    }
  });
}

export const activateButton = (index) => {
  let button = document.querySelector(`[href="#data-ps-${index}"]`);
  if (!button) return;
  button.classList.add('active');
  button.parentElement.querySelectorAll('.kb-button').forEach(btn => {
    if (btn !== button) {
      btn.classList.remove('active');
    }
  });
}
